import { render } from "./HjpSideBar.vue?vue&type=template&id=0cdff630&ts=true"
import script from "./HjpSideBar.vue?vue&type=script&lang=ts"
export * from "./HjpSideBar.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/harapan-jaya/ecosystem/web-hrd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__